import React from 'react';
import { Group, List, FixedLayout, Button, Div, PullToRefresh } from '@vkontakte/vkui';
import DefaultPanel from "../classes/DefaultPanel";
import BillList from "../components/BillList";
import { connect } from "react-redux";
import {setBills, setEndReached, setRefund, setTodaySum, startLoading} from "../store/bills/actions";
import {getBills, getTodaySum} from "../services/db";


class PanelBills extends DefaultPanel {

	state = {
        fetching: false,
	};

	settings() {
		this.title = <div className="double-title"><div className="top-title">Платежи</div><div className="bottom-subtitle">{ this.props.organization }</div></div>;
		this.theme = 'gray';
	}

	openPay = () => {
		this.openPage('pay');
	};

	pComponentDidMount = async() => {
		if (this.props.cashier_id !== undefined) {
            const getSumResult = await getTodaySum(this.props.cashier_id);

            if (getSumResult.data !== undefined && getSumResult.data.data !== undefined && getSumResult.data.data.sum !== undefined) {
                this.props.dispatch(setTodaySum(getSumResult.data.data.sum, getSumResult.data.data.refundSum,));
            }
        }
	};

	onRefresh = async() => {
        this.setState({ fetching: true });

        const bills = await this.props.dispatch(getBills(this.props.cashier_id, this.props.limit, 0));
        if (bills.result !== undefined && bills.result === 'success') {
        	if (bills.data.data.data.length > 0) this.props.dispatch(setBills(bills.data.data.data));
            if (bills.data.data.data.length < this.props.limit) this.props.dispatch(setEndReached());

            // Сумма платежей сегодня
            const getSumResult = await getTodaySum(this.props.cashier_id);
            if (getSumResult.data !== undefined && getSumResult.data.data !== undefined && getSumResult.data.data.sum !== undefined) this.props.dispatch(setTodaySum(getSumResult.data.data.sum, getSumResult.data.data.refundSum,));
        }

        this.setState({ fetching: false });
	};

	renderPanel() {
		return(
			<React.Fragment>
				<Div className="today-sum">
					<div className="sum">
						<div className="title">Cумма за сегодня</div>
						<div className="value">{ this.props.todaySum } ₽</div>
					</div>
					<div className="refund">
                        <div className="title">Возвраты сегодня</div>
                        <div className="value">{ this.props.todayRefund } ₽</div>
					</div>
					</Div>
                <PullToRefresh onRefresh={ this.onRefresh } isFetching={ this.state.fetching }>
					<BillList/>
				</PullToRefresh>
				{ (JSON.stringify(this.props.bills) === JSON.stringify({}) && !this.props.isBillsLoading) && <Div className="soon">Скоро здесь появятся платежи от ваших покупателей</Div> }
				<FixedLayout vertical="bottom" className='fixed-bottom'>
					<Button size="xl" onClick={ this.openPay }>Провести платеж</Button>
				</FixedLayout>
			</React.Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        organization: state.cashier.cashier.organization,
        todaySum: state.bills.todaySum,
        todayRefund: state.bills.todayRefund,
        cashier_id: state.cashier.cashier.cashier_id,
		bills: state.bills.bills,
        isBillsLoading: state.bills.isBillsLoading,
        limit: state.bills.limit,
    };
}

export default connect(mapStateToProps)(PanelBills);


// WEBPACK FOOTER //
// ./src/js/panels/PanelBills.js